// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___VqTUa","video":"index-module__video___22pUa"};